/**
 * Sayfa tanıtım turu adımları.
 * Her adım bir DOM öğesini (data-tour) hedefler; öğe yoksa adım otomatik atlanır.
 * forceInclude: görünür olmasa da dahil et (action ile açılacak paneller).
 */

const TOUR_UI = "ansiklopedi:tour-ui";

function setTourUi({ menu = false, search = false } = {}) {
  window.dispatchEvent(new CustomEvent(TOUR_UI, { detail: { menu, search } }));
}

export function ensureMenuOpen() {
  setTourUi({ menu: true, search: false });
}

export function ensureSearchOpen() {
  setTourUi({ menu: false, search: true });
}

export function ensureTourUiClosed() {
  setTourUi({ menu: false, search: false });
}

/** Tur kapanınca çağrılır: tur nedeniyle açılan panelleri geri kapat. */
export function closeTourSideEffects() {
  ensureTourUiClosed();
  ensureItemLinkPopupClosed();
}

export function ensureItemLinkPopupOpen() {
  window.dispatchEvent(
    new CustomEvent("ansiklopedi:tour-item-link", { detail: { open: true } })
  );
}

export function ensureItemLinkPopupClosed() {
  window.dispatchEvent(
    new CustomEvent("ansiklopedi:tour-item-link", { detail: { open: false } })
  );
}

export const HOME_TOUR_STEPS = [
  {
    target: '[data-tour="menu-panel"]',
    title: "Menü",
    body: "Açık menüden Hakkında, Maddeler, Yazarlar, Madde Öner, Kılavuz, Çalışma Grubu, Emeği Geçenler, Künye ve Mobil Uygulama bölümlerine ulaşabilirsiniz.",
    placement: "right",
    forceInclude: true,
    action: ensureMenuOpen,
  },
  {
    target: '[data-tour="logo"]',
    title: "Ana sayfa",
    body: "Logoya tıklayarak her zaman ana sayfaya dönebilirsiniz.",
    placement: "bottom",
    action: ensureTourUiClosed,
  },
  {
    target: '[data-tour="search-results"]',
    title: "Arama sonuçları",
    body: "En az 3 karakter yazınca sonuçlar açılır. Üç sekme vardır: Başlık (madde adları), İçerik (metinde geçenler) ve Yazar. Sekmeler arasında geçerek ilgili gruba bakın. Enter veya Ara ile tam arama sayfasına da gidebilirsiniz.",
    placement: "bottom",
    forceInclude: true,
    action: ensureSearchOpen,
  },
  {
    target: '[data-tour="new-items"]',
    title: "Ansiklopedide yeni",
    body: "En son yayımlanan maddeler burada yer alır.",
    placement: "top",
    action: ensureTourUiClosed,
  },
  {
    target: '[data-tour="latest-link"]',
    title: "Son eklenenler",
    body: "Tüm son eklenen maddeleri tarihe göre gruplanmış olarak görmek için tıklayın.",
    placement: "left",
    action: ensureTourUiClosed,
  },
  {
    target: '[data-tour="authors"]',
    title: "Yazarlar",
    body: "Ansiklopediye katkı sağlayan yazarları buradan keşfedebilirsiniz.",
    placement: "top",
    action: ensureTourUiClosed,
  },
  {
    target: '[data-tour="random-article"]',
    title: "Rastgele madde",
    body: "Günün maddelerinden rastgele birini okuyun; Yenile ile başka madde seçebilirsiniz.",
    placement: "top",
    action: ensureTourUiClosed,
  },
  {
    target: '[data-tour="images"]',
    title: "Görseller",
    body: "Ansiklopediden rastgele görseller ve ilgili maddelere bağlantılar burada gösterilir.",
    placement: "top",
    action: ensureTourUiClosed,
  },
  {
    target: '[data-tour="mobile-app"]',
    title: "Mobil uygulama",
    body: "Google Play ve App Store üzerinden mobil uygulamayı indirebilir; QR kod ile de taratabilirsiniz.",
    placement: "right",
    action: ensureTourUiClosed,
  },
];

export const DETAIL_TOUR_STEPS = [
  {
    target: '[data-tour="item-title"]',
    title: "Madde başlığı",
    body: "Okuduğunuz maddenin adı ve varsa kısa tanımı burada yer alır.",
    placement: "bottom",
  },
  {
    target: '[data-tour="item-authors"]',
    title: "Yazarlar",
    body: "Maddeyi kaleme alan yazarlara tıklayarak yazar detayına gidebilirsiniz.",
    placement: "bottom",
  },
  {
    target: '[data-tour="item-actions"]',
    title: "Madde araçları",
    body: "PDF indirme, yazdırma, atıf bilgisi ve bildirim formuna buradan ulaşın.",
    placement: "left",
  },
  {
    target: '[data-tour="customizer"]',
    title: "Okuma ayarları",
    body: "Yazı hizası, punto ve arka plan rengini buradan kişiselleştirebilirsiniz.",
    placement: "left",
  },
  {
    target: '[data-tour="item-content"]',
    title: "Madde metni",
    body: "Ansiklopedi maddesinin asıl içeriği bu alanda yer alır. Metin içinde geçen diğer madde adları otomatik olarak bağlantıya dönüştürülür.",
    placement: "top",
    action: ensureItemLinkPopupClosed,
  },
  {
    target: '.item-link-popover',
    title: "İlişkili madde popup’ı",
    body: "Bağlantılı madde adının üzerine gelince (masaüstü) veya dokununca (mobil) bir popup açılır. Özet, varsa görsel ve “İlgili maddeye git” bağlantısı burada görünür.",
    placement: "top",
    forceInclude: true,
    action: ensureItemLinkPopupOpen,
  },
  {
    target: '[data-tour="related"]',
    title: "İlişkili maddeler",
    body: "Bu maddeyle bağlantılı veya diğer maddeleri burada görebilirsiniz.",
    placement: "left",
    action: ensureItemLinkPopupClosed,
  },
];

export const STEPS_BY_PAGE = {
  home: HOME_TOUR_STEPS,
  detail: DETAIL_TOUR_STEPS,
};
